<div class="container-fluid d-flex flex-column h-100 px-0">
    <div class="row flex-fill h-100  pb-2 pt-0 m-0 px-0">
      <div class="col-12 d-flex flex-column h-100 px-0 table-wrapper table-height transaction-height">
          <div class="d-flex flex-column h-100 flex-fill">
            <app-ag-grid
            id="customerList"
            [isFilter]="true"
            class="d-flex flex-column h-100" 
            [dataModel]="agGridDataModelTransactionHistoryList"
            [rowHeight]="40"
            (onPageSizeUpdated)="onChnagePage($event)"
            (onPageSizeChanged)="paymentVoucherList.pageSize = $event; getAllPaymentVoucherData()"
            [pageSize]="paymentVoucherList.pageSize"
            [page]="paymentVoucherList.pageNumber"
            [totalRecords]="totalRecords"
            (gridReady)="onGridReady($event)"
            [rowHeight] ="40"
            ></app-ag-grid> 
          </div>
      </div>
  </div>
</div>    